import { render, staticRenderFns } from "./rate-remote.vue?vue&type=template&id=796ce83e&scoped=true&lang=pug&"
import script from "./rate-remote.vue?vue&type=script&lang=js&"
export * from "./rate-remote.vue?vue&type=script&lang=js&"
import style0 from "./rate-remote.vue?vue&type=style&index=0&id=796ce83e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ce83e",
  null
  
)

export default component.exports